<svg
	fill="currentColor"
	width="30px"
	height="30px"
	viewBox="0 0 24 24"
	id="no-water"
	data-name="Line Color"
	xmlns="http://www.w3.org/2000/svg"
	class="icon line-color"
>
	<g id="SVGRepo_bgCarrier" stroke-width="0" />

	<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

	<g id="SVGRepo_iconCarrier">
		<path
			id="primary"
			d="M18.32,10.68A9,9,0,0,1,19,14,7,7,0,0,1,8.78,20.22"
			style="fill: none; stroke: currentColor; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"
		/>

		<path
			id="primary-2"
			data-name="primary"
			d="M16.5,7.5A22.54,22.54,0,0,0,12,3S5,8,5,14a6.92,6.92,0,0,0,1.15,3.85"
			style="fill: none; stroke: currentColor; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"
		/>

		<line
			id="secondary"
			x1="20"
			y1="4"
			x2="4"
			y2="20"
			style="fill: none; stroke: currentColor; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"
		/>
	</g>
</svg>
